<template>
  <v-container fluid>

  <div class="headline text-xs-left">
    Delivery Help
  </div>

  <LearnItem>
    <template slot="title">What do the delivery types mean?</template>
    <b>In person</b> delivery means you will deliver the item to the buyer directly (no shipping).
    If you are mainly selling to family and friends this is a nice option.
    <br /><br />
    <b>By mail</b> means you will ship the orders to customers. If you expect buyers
    who are far away from you and possibly people you don't know, this is a good option.
    <br /><br />
    Set these options in your <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link> page.

   </LearnItem>

   <LearnItem>
     <template slot="title">What do the shipping options mean?</template>
     For delivery by mail SmartKidsMarket can add on a shipping charge.

     The shipping charge is only an estimate and depending on the shipping option you
     choose and the shipping company you may pay more or less to actually ship the order.

     You are still responsible for shipping the item to the buyer.
     <br /><br />There are 4 types of
     shipping you can select on your <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
     page.
     <br /><br />
     <ul>
       <li>
         <b>Free delivery</b> means buyers will not be required to pay for shipping.
         This is preferred by buyers, but you should adjust your prices to make sure you
         don't lose money because you have to pay all shipping costs.
       </li>
       <li>
         <b>Flat rate shipping</b> means buyers will be required to pay a single fee
         for shipping an order. You can set this fee on the <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
         when you choose this option.
       </li>
       <li>
         <b>Flat rate per item shipping</b> each order will add a shipping cost per item.
         For example, if you set the rate per item to $5 and a buyer orders 3 items, the
         shipping charge will be $15. You can set the rate on the <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
         when you choose this option.
       </li>
       <li>
         <b>USPS Computed rate shipping</b> attempts to compute what size box the order will fit into.
         Using USPS flat rate boxes. To use this option you must set the dimensions of your
         items for sale on the item's page. Without the dimensions the system cannot compute a
         USPS rate. The minimum rate for a small flat rate box is $7.90 currently. <br /><br />
         See <a href="https://www.usps.com/ship/priority-mail.htm">USPS.COM</a> for more information.
       </li>
     </ul>
  </LearnItem>
  <LearnItem>
    <template slot="title">How to use USPS computed delivery?</template>
    SmartKidsMarket can estimate the size of the box needed for your items based
    on their dimensions (length, width, height). You must provide the item dimensions
    on the item's description page. <br /><br />
    The shipping charge will then be computed based on which USPS flat rate box
    the items may fit into. The system can only estimate and may not be 100% accurate.
    You are still responsible for the cost of shipping the items to the buyer.
    Currently the smallest flat rate box costs $7.90 to mail.
    <br /><br />
    See <a href="https://www.usps.com/ship/priority-mail.htm">USPS.COM</a> for more information.
   </LearnItem>

  </v-container>

</template>

<script>

import LearnItem from './LearnItem.vue'

export default {
  components: {
    LearnItem
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
